import { render, staticRenderFns } from "./TableViewSection.vue?vue&type=template&id=4ef3dd79&scoped=true&"
import script from "./TableViewSection.vue?vue&type=script&lang=js&"
export * from "./TableViewSection.vue?vue&type=script&lang=js&"
import style0 from "./TableViewSection.vue?vue&type=style&index=0&id=4ef3dd79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_css-loader@6.8.1_lodash@4.17.21_prettier@3.0.3_r_gaeimbjcwu57yzcey4waijeptq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef3dd79",
  null
  
)

export default component.exports